export class UnlockPersonaRequest {
  public id_Persona!: number
}
